// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d8855e3a","455":"1af4116a","488":"e6c00933"}[chunkId] + ".chunk.js";
};